import React, { useState, useEffect } from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
// Make sure the file exists at the specified path, or update the path if needed
import TrainersTable from './components/TrainersTable';

const TrainersList: React.FC = () => {
    const { user, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/auth/sign-in');
        }
    }, [user, isAuthenticated, navigate]);

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
            <SimpleGrid gap='20px' mb='20px'>
                <TrainersTable />
                <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
                    {/* Future additional cards can go here */}
                </SimpleGrid>
            </SimpleGrid>
        </Box>
    );
};

export default TrainersList;
